
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/navipay",
      function () {
        return require("private-next-pages/navipay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/navipay"])
      });
    }
  